import { Geolocation } from ".."

export interface Location {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    names: {
        [key: string]: string
    }
    geolocation: Geolocation
}

export interface PagedLocation {
    items: Location[]
    totalCount: number
}

export const LOCATION_FIELD_LABELS: Record<string, string> = {
    names: "Naziv",
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    geolocation: "Lokacija",
}
